import { httpPost } from '../../utils/httpClients';
import { CO_HEALTH_CHECK_URL } from '../../constants';
import { HEALTH_CHECK_TYPE } from '../../constants/health-check';

export const postHealthCheck = (
  allySlug: string,
  component: HEALTH_CHECK_TYPE
): void => {
  try {
    httpPost(CO_HEALTH_CHECK_URL, '', {
      allySlug,
      component,
    });
  } catch (error) {
    console.error('[addi]: ', error);
  }
};
